import { AxiosClient } from '@/service/axiosClient'
import { IGuestCreateParam, IGuestUpdateParam } from '@/service/models/guest'
import { AxiosResp } from '@/types'
import { IGuest } from '@/types/interfaces/guest'

/** 게스트 API */
export const guestApi = {
  /** 게스트 생성 (회사 아이디 기준) */
  create: (companyId: number, params: IGuestCreateParam) =>
    AxiosClient.post<AxiosResp<{ id: number }>>(`/guests/by-company-id/${companyId}`, params),

  /** 게스트 수정 (회사 아이디 기준) */
  update: (companyId: number, id: number, params: IGuestUpdateParam) =>
    AxiosClient.put<AxiosResp<{ id: number }>>(`/guests/by-company-id/${companyId}/${id}`, params),

  /** 게스트 단일 조회 (회사 아이디 기준) */
  getDetail: (companyId: number, id: number) =>
    AxiosClient.get<AxiosResp<IGuest>>(`/guests/by-company-id/${companyId}/${id}`),
}
